<script lang="ts">
  import { page } from "$app/stores";
  import Winners from "./Winners.svelte";
  import FAQ from "../FAQ.svelte";
  import DataTable from "../DataTable/DataTable.svelte";
  import Translate from "../../helpers/Translate.svelte";
  import { onMount } from "svelte";
  import { getTournamentsPageData } from "../DataTable/dataFetcher";
  import AboutTournamentProvider from "./AboutTournamentProvider.svelte";
  import Content from "../Content/index.svelte";
  import Image from "../Images/index.svelte";
  import imports from "../../Importer";
  import Breadcrumbs from "$lib/main/components/Breadcrumbs.svelte";

  export let tournamentId: number;
  let imageContent;
  let secondContent;
  let tournamentsTabs;
  let faq;
  let aboutTournamentProvider;

  onMount(async () => {
    imageContent = await getTournamentsPageData("Image");
    secondContent = await getTournamentsPageData("Content", 2);
    faq = await getTournamentsPageData("FAQ");
    tournamentsTabs = await getTournamentsPageData("DataTable");
    aboutTournamentProvider = await getTournamentsPageData("AboutTournamentProvider");
  });

  const leaderboardProps = {
    tabs: [
      {
        title: "Leaderboard",
        isOpen: true,
        endpoint: "leaderboard",
        additionalArgs: {
          tournamentId: tournamentId,
        },
        selectedColumns: [
          {
            key: "position",
            displayName: "",
          },
          {
            key: "playerName",
            displayName: "Name",
          },
          {
            key: "playerScore",
            displayName: "Score",
          },
        ],
        endpointSelected: true,
      },
    ],
    hideHeader: false,
    isAccordion: true,
  };
</script>

<Breadcrumbs path={$page.url.pathname} hasDarkMode={true} />
{#if imageContent && imageContent.props}
  <Image
    this={imports[imageContent.blockType].cls}
    bind:props={imageContent.props}
    adminView={false}
    hasContainer={true} />
{/if}

<div class="container">
  <Winners {tournamentId} />
</div>

<div class="container leaderboard-container">
  <div class="leaderboard">
    <DataTable props={leaderboardProps} />
  </div>
</div>

{#if tournamentsTabs && tournamentsTabs.props}
  <div class="container">
    <DataTable props={tournamentsTabs.props} />
  </div>
{/if}

{#if secondContent}
  <Content props={secondContent.props} />
{/if}

{#if faq && faq.props && faq.props.content}
  <FAQ props={faq.props} />
{/if}

{#if aboutTournamentProvider && aboutTournamentProvider.props}
  <AboutTournamentProvider props={aboutTournamentProvider.props} />
{/if}

<style>
  .leaderboard-container {
    margin-top: 30px;
  }

  .text {
    min-width: 0;
    grid-area: text;
  }

  .image {
    min-width: 0;
    grid-area: image;
  }
</style>
